import { dismissHotLead } from 'actions/RecommendationActions'
import { getListName } from 'analytics/enhanced-ecommerce'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import noop from 'lib/function/noop'
import { isLEHotel } from 'lib/offer/offerTypes'
import moment from 'moment'
import React, { useCallback } from 'react'
import getCheckInOutText from '../../utils/getCheckInOutText'
import ParameterizedStickyCard from '../ParameterizedStickyCard'
import { getOccupancyText } from 'components/Recommendations/utils/getOccupancyText'
import { getFirstHotLead } from 'selectors/recomendations/hotLeadSelectors'
import { getHotLeadDurationText } from 'lib/offer/highIntentOffers'
import { HotLeadDataView } from 'hooks/Recommendation/useHotLeadData'

interface Props {
  hotLeadData: HotLeadDataView
  onClose?: () => void
  show: boolean
  stickyTop?: number
}

const analyticsListName = getListName('LERE', 'global', 'Sticky Hot Leads')
const analyticsCardType = 'sticky_hot_lead'
const cardHeading = 'Continue your booking'

function StickyHotLeadCard({
  hotLeadData: {
    offer,
    checkIn,
    checkOut,
    duration,
    occupancy,
    price,
    discountPercent,
    offerUrl,
  }, onClose = noop, show, stickyTop,
}: Props) {
  const offerId = offer.id

  // rendered properties
  const offerDisplayName = isLEHotel(offer) ? offer?.property?.name : offer.name
  const checkInMoment = checkIn ? moment(checkIn) : undefined
  const checkOutMoment = checkOut ? moment(checkOut) : undefined
  const durationText = getHotLeadDurationText(duration, offer.type)
  const checkInOutText = getCheckInOutText(checkInMoment, checkOutMoment)
  const occupancyText = getOccupancyText(occupancy, offer.saleUnit)
  const image = offer.image

  // analytics properties
  const offerAnalyticsType = offer.analyticsType

  const dispatchAction = useAppDispatch()

  const hotLead = useAppSelector(getFirstHotLead)
  const handleDismiss = useCallback(() => {
    dispatchAction(dismissHotLead(hotLead))
    onClose()
  }, [dispatchAction, onClose, hotLead])

  const cardProperties = {
    offerDisplayName,
    durationText,
    checkInOutText,
    occupancyText,
    image,
    price,
    discountPercent,
    analyticsListName,
    offerId,
    offerAnalyticsType,
    analyticsCardType,
    cardHeading,
    toUrl: offerUrl,
    onClick: noop,
    onClose: handleDismiss,
    show,
    stickyTop,
  }

  return (
    <ParameterizedStickyCard {...cardProperties} />
  )
}

export default StickyHotLeadCard
